import React, { useState, useEffect } from 'react';

export const useCancelationPolicies = () => {
  const [isLoading, setIsLoading] = useState(false);
  let spacesData = [
  ];

  /*
  useEffect(() => {
    if (spacesData.length >= 1) {
      setIsLoading(false);
    }
  }, [spacesData]);
  */

  return {
    isLoading,
    setIsLoading,
    spacesData,
  };
};
